<template>
  <!-- 专业助教PA -->
  <div class="PA">
    <PublicCert :logo="Logo2" :type="'pa'" :color="'#2b257b'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo2 from '@/assets/images/logo2.png'

export default {
  name: 'PA',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo2
    }
  }
}
</script>
